(() => {
  const pageHasOwnScrollLock = () =>
    Boolean(
      document.querySelector(
        'cart-drawer.active, .menu-open, .menu-opening, dialog[open], details[open] > .search-modal, modal-dialog[open], header-drawer details[open]'
      )
    );

  const hideKlaviyoOverlays = () => {
    document
      .querySelectorAll(
        '#klaviyo-tos-container, klaviyo-onsite-overlay, klaviyo-onsite-embed, klaviyo-onsite-popup, .kl-teaser, .kl-teaser-wrapper, [class*="klaviyo-form"], [class*="klaviyo-popup"], [class*="klaviyo-onsite"], [class*="kl-private"], [id^="klaviyo-form"], iframe[src*="klaviyo"]'
      )
      .forEach((el) => {
        if (el === document.documentElement || el === document.body) return;
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
        el.style.setProperty('opacity', '0', 'important');
      });
  };

  const clearForeignScrollLock = () => {
    if (pageHasOwnScrollLock()) return;
    const html = document.documentElement;
    const body = document.body;
    ['overflow', 'overflow-x', 'overflow-y', 'height', 'position', 'top', 'left', 'width'].forEach((prop) => {
      html.style.removeProperty(prop);
      body.style.removeProperty(prop);
    });
    body.classList.remove(
      'overflow-hidden',
      'overflow-hidden-mobile',
      'overflow-hidden-tablet',
      'overflow-hidden-desktop'
    );
    ['kl-prevent-body-scroll', 'kl-modal-open', 'klaviyo-modal-open'].forEach((name) => {
      html.classList.remove(name);
      body.classList.remove(name);
    });
  };

  const sweep = () => {
    document.body.classList.add('beau-hide-discount-popup');
    hideKlaviyoOverlays();
    clearForeignScrollLock();
  };

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') sweep();
  });
  window.addEventListener('pageshow', sweep);
  window.addEventListener('focus', sweep);
  document.addEventListener('pointerup', sweep, { passive: true });
  document.addEventListener('DOMContentLoaded', sweep);
  window.addEventListener('load', sweep);
  sweep();

  /* Fast while Klaviyo typically injects, then a slow always-on watch
     for late / exit-intent overlays. No MutationObserver (editor freeze). */
  const fast = window.setInterval(sweep, 600);
  window.setTimeout(() => {
    window.clearInterval(fast);
    window.setInterval(sweep, 2500);
  }, 90000);

  const root = document.querySelector('[data-beau-signup]');
  if (!root) return;

  const panel = root.querySelector('#BeauSignupPanel');
  const toggle = root.querySelector('[data-signup-toggle]');
  const doneKey = 'beau-signup-done';

  if (window.localStorage.getItem(doneKey) === '1') {
    root.hidden = true;
    return;
  }

  const setOpen = (open) => {
    root.classList.toggle('is-open', open);
    if (panel) panel.hidden = !open;
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  toggle?.addEventListener('click', () => {
    setOpen(!root.classList.contains('is-open'));
  });

  root.querySelector('[data-signup-close]')?.addEventListener('click', () => setOpen(false));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setOpen(false);
  });

  if (root.querySelector('[data-signup-success]')) {
    setOpen(true);
    window.localStorage.setItem(doneKey, '1');
    window.setTimeout(() => {
      setOpen(false);
      root.hidden = true;
    }, 2800);
  }
})();
